import { Tracktable } from "../../components/datatable/Tracktable";

const Tracking = () => {
  return <Tracktable />;
};

export default Tracking;
